module.exports = __webpack_public_path__ + "static/media/big-white-cross.da16a1eb.svg";